import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaYoutube, FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLang, setShowLang] = useState(true);

  // About Us dropdown
  const [aboutOpen, setAboutOpen] = useState(false);
  const aboutRef = useRef(null);
  const aboutHoverTimeout = useRef(null);

  // Details dropdown (YENİ)
  const [detailsOpen, setDetailsOpen] = useState(false);
  const detailsRef = useRef(null);
  const detailsHoverTimeout = useRef(null);

  const SHOW_COURSES = false;
  const SHOW_CAMPS = false;

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Google Translate yükle
  useEffect(() => {
    if (window.google && window.google.translate) return;
    window.__googleTranslateInit = () => {
      try {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", includedLanguages: "en,tr", autoDisplay: false },
          "google_translate_element"
        );
      } catch (e) {}
    };
    const s = document.createElement("script");
    s.src =
      "https://translate.google.com/translate_a/element.js?cb=__googleTranslateInit";
    document.body.appendChild(s);
  }, []);

  // Dil değiştirici
  const translateTo = (code) => {
    const combo = document.querySelector("select.goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
    }
  };

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
    translateTo(newLang);
    setShowDropdown(false);
  };

  // Scroll davranışı
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      setShowLang(!(window.scrollY > lastScrollY && window.scrollY > 100));
      lastScrollY = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // About hover handlers
  const handleAboutEnter = () => {
    clearTimeout(aboutHoverTimeout.current);
    setAboutOpen(true);
  };
  const handleAboutLeave = (e) => {
    if (!aboutRef.current?.contains(e.relatedTarget)) {
      aboutHoverTimeout.current = setTimeout(() => setAboutOpen(false), 200);
    }
  };
  const handleAboutClick = () => setAboutOpen((p) => !p);

  // Details hover handlers (YENİ)
  const handleDetailsEnter = () => {
    clearTimeout(detailsHoverTimeout.current);
    setDetailsOpen(true);
  };
  const handleDetailsLeave = (e) => {
    if (!detailsRef.current?.contains(e.relatedTarget)) {
      detailsHoverTimeout.current = setTimeout(() => setDetailsOpen(false), 200);
    }
  };
  const handleDetailsClick = () => setDetailsOpen((p) => !p);

  return (
    <header className="navbar small-navbar">
      <div className="nav-container">
        {/* 🔹 LOGO (Görsel yerine düz yazı) */}
        <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
          <span className="logo-text">OTTOMUN</span>
        </Link>

        {/* 🔹 Mobil Menü */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* 🔹 Menü Linkleri */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>

          {/* Academic Team: TEK LİNK OLARAK KALIYOR */}
          <Link to="/academic-team" onClick={() => setMenuOpen(false)}>
            Academic Team
          </Link>

          {/* Details dropdown: Committees + Code of Conduct */}
          <div
            ref={detailsRef}
            className={`nav-item details-item ${detailsOpen ? "active" : ""}`}
            onMouseEnter={handleDetailsEnter}
            onMouseLeave={handleDetailsLeave}
          >
            <span className="nav-link" onClick={handleDetailsClick}>
              Details ▾
            </span>

            {detailsOpen && (
              <div
                className="submenu submenu-down"
                onMouseEnter={handleDetailsEnter}
                onMouseLeave={handleDetailsLeave}
              >
                <Link to="/details/committees" onClick={() => setMenuOpen(false)}>
                  Committees
                </Link>
                <Link to="/details/conduct" onClick={() => setMenuOpen(false)}>
                  Code of Conduct
                </Link>
              </div>
            )}
          </div>

          {SHOW_COURSES && (
            <Link to="/courses" onClick={() => setMenuOpen(false)}>
              Courses
            </Link>
          )}

          <Link to="/apply" onClick={() => setMenuOpen(false)}>
            Apply
          </Link>

          {/* About Us dropdown */}
          <div
            ref={aboutRef}
            className={`nav-item about-item ${aboutOpen ? "active" : ""}`}
            onMouseEnter={handleAboutEnter}
            onMouseLeave={handleAboutLeave}
          >
            <span className="nav-link" onClick={handleAboutClick}>
              About Us ▾
            </span>

            {aboutOpen && (
              <div
                className="submenu submenu-down"
                onMouseEnter={handleAboutEnter}
                onMouseLeave={handleAboutLeave}
              >
                <Link to="/about/mission" onClick={() => setMenuOpen(false)}>
                  Our Mission
                </Link>
                <Link to="/about/vision" onClick={() => setMenuOpen(false)}>
                  Our Vision
                </Link>
                <Link to="/about/excellence" onClick={() => setMenuOpen(false)}>
                  Ottomun Excellence
                </Link>
              </div>
            )}
          </div>

          {SHOW_CAMPS && (
            <Link to="/camps" onClick={() => setMenuOpen(false)}>
              MUN Camps
            </Link>
          )}
        </nav>

        {/* 🔹 Sağdaki ikonlar */}
        <div className="nav-icons">
          <a
            href="https://www.instagram.com/sharronxenos_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.youtube.com/@majoleeducation4028"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>

          {/* 🔹 Dil seçici */}
          <div className={`lang-icon ${showLang ? "visible" : "hidden"}`}>
            <span
              onClick={() => setShowDropdown(!showDropdown)}
              className="lang-trigger"
            >
              {lang.toUpperCase()}
            </span>
            {showDropdown && (
              <div className="lang-dropdown">
                {lang === "en" ? (
                  <button onClick={() => changeLang("tr")}>TR</button>
                ) : (
                  <button onClick={() => changeLang("en")}>EN</button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 🔹 Google Translate kapsayıcısı */}
      <div id="google_translate_element" style={{ display: "none" }} />
    </header>
  );
};

export default Navbar;
